import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { TIPS_STATUS } from '../../features/widgets/components/Tips/constants';

type SentTipType = {
  ClientId?: string;
  ClientIP?: string;
  CurrentPlayerToken?: string;
  MessageType: 'PlaceTip';
  destination: 'table';
  gameType?: string | number;
  TableId: string;
  tipValue: number;
}

const { INITIAL, SUCCESS, FAILURE } = TIPS_STATUS;

const initialState = {
  loading: false,
  status: INITIAL,
  show: false,
};

const tipsSlice = createSlice({
  name: 'tips',
  initialState,
  reducers: {
    toggleSuccess(state) {
      return {
        ...state,
        show: !state.show,
        status: state.show ? INITIAL : state.status,
      };
    },
    toggleRequest() {},
    toggleFailure() {}, // remove? called, but no handler
    request(state) {
      return {
        ...state,
        loading: true,
      };
    },
    success(state) {
      return {
        ...state,
        status: SUCCESS,
        loading: false,
      };
    },
    failure(state) {
      return {
        ...state,
        status: FAILURE,
        loading: false,
      };
    },
    reset(state) {
      return {
        ...state,
        ...initialState,
      };
    },
    send(_state, { payload: _ }: PayloadAction<SentTipType>) {},
  },
});

export const tipsActions = tipsSlice.actions;
export default tipsSlice.reducer;
